import { Modal } from "react-bootstrap"

const DialogModal = ({ show, setShow, title, text, onSubmit, loader }) => {
    // Always called with an explicit `false`. `onHide={() => setShow()}` passed
    // undefined straight into the caller's state setter, so dismissing with
    // ESC or a backdrop click wiped the dialog state and the next read of
    // `dialog.show` threw.
    const close = () => setShow(false);

    return (
        <Modal show={show} onHide={close} centered>
            <Modal.Header closeButton><h3 className="dialog-modal-text">{title}</h3></Modal.Header>
            <Modal.Body><span className="dialog-modal-text">{text}</span></Modal.Body>
            <Modal.Footer>
                <div className="modal-action-buttons">
                    <button type="button" onClick={onSubmit} disabled={loader} className="submit-modal-form-btn">
                        {loader ? <div className="button-loader"></div> : "Yes"}
                    </button>
                    <button type="button" onClick={close} disabled={loader} className="cancel-modal-form-btn">No</button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default DialogModal
